<template>
  <v-row class="status">
    <v-col cols="12" v-if="!isBlocked">
      <WidgetBonuses />
    </v-col>
  </v-row>
</template>

<script>

import WidgetBonuses from '../../../components/widget-bonuses/WidgetBonuses.vue';

export default {
  components: { WidgetBonuses },
  computed: {
    isBlocked() { return !!(this.$store.getters.isBlocked); },
  },
};
</script>

<style scoped lang="scss">

</style>
